import { render, staticRenderFns } from "./welcomeMessage.vue?vue&type=template&id=48ddafe5&scoped=true"
import script from "./welcomeMessage.vue?vue&type=script&lang=js"
export * from "./welcomeMessage.vue?vue&type=script&lang=js"
import style0 from "./welcomeMessage.vue?vue&type=style&index=0&id=48ddafe5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ddafe5",
  null
  
)

export default component.exports